require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-justin-mcdowell.json") })
        }
      }, "path---blog-author-justin-mcdowell");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-justin-mcdowell!./.cache/json/blog-author-justin-mcdowell.json
// module id = 663
// module chunks = 231608221292675